import React, { useEffect, useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import './ConfirmEmailPage.scss';
import { confirmEmailRequest } from '@/api';
import logo from '@/img/propsavvy-logo-with-text.svg';
import Button from '@/components/shared/Button';
import { setAuthTokens, isAuthenticatedSelector } from '@/store/auth/authSlices';
import { fetchProfileSuccess } from '@/store/profile/profileSlices';

const baseClass = 'ConfirmEmailPage';

const ConfirmEmailPage = () => {
  const { token } = useParams();
  const [message, setMessage] = useState('');
  const [isErrorState, setIsErrorState] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isAuthenticated = useSelector(isAuthenticatedSelector);

  useEffect(() => {
    const confirmEmail = async (token: string) => {
      console.log('ConfirmEmailPage: Starting email confirmation process...');
      try {
        const response = await confirmEmailRequest(token);
        const { message, accessToken, refreshToken, user } = response.data;

        console.log('ConfirmEmailPage: API response received:', response.data);

        if (accessToken && user) {
          console.log('ConfirmEmailPage: AccessToken and user found. Dispatching auth tokens and profile...');
          dispatch(setAuthTokens(accessToken));
          dispatch(fetchProfileSuccess(user));
          setMessage('Email confirmed successfully! You are now logged in.');
          console.log('ConfirmEmailPage: Dispatches completed.');

          setTimeout(() => {
            console.log('ConfirmEmailPage: isAuthenticated after dispatches (with delay):', isAuthenticated);
            console.log('ConfirmEmailPage: localStorage accessToken after dispatches (with delay):', localStorage.getItem('accessToken'));
          }, 100);

        } else {
          setMessage(message || 'Email confirmed successfully!');
          console.log('ConfirmEmailPage: No accessToken or user in response, or message only.');
        }
      } catch (e: any) {
        console.error('ConfirmEmailPage: Error during email confirmation:', e);
        const apiErrorMessage = e?.response?.data?.message || e?.message || 'An unknown error occurred.';
        
        setMessage(apiErrorMessage); // Display the exact message from API

        if (e?.response?.status === 404 && apiErrorMessage.includes('Confirmation token is invalid')) {
          setIsErrorState(true); // Set error state for button logic
        } else {
          setIsErrorState(false); // Ensure error state is false for other errors
        }
      }
    };

    if (token) {
      confirmEmail(token);
    }
  }, [token, dispatch, isAuthenticated]);

  const handleBackToHome = () => {
    console.log('ConfirmEmailPage: "Back" button clicked.');
    console.log('ConfirmEmailPage: isAuthenticated at button click:', isAuthenticated);
    console.log('ConfirmEmailPage: localStorage accessToken at button click:', localStorage.getItem('accessToken'));
    if (isErrorState) {
      navigate('/login');
    } else {
      navigate('/');
    }
  };

  return (
    <div className={baseClass}>
      <div className={`${baseClass}-view`}>
        <div className={`${baseClass}-view-logo`}>
          <img src={logo} alt="logo" />
        </div>
        <div className={`${baseClass}-view-form`}>
          <h3 className={isErrorState ? `${baseClass}-error-message` : ''}>{message}</h3>
          <div className={`${baseClass}-view-form-group`}>
            <Button onClick={handleBackToHome} className={`${baseClass}-view-form-group-submit-btn`}>
              {isErrorState ? 'Back to login' : 'Back to dashboard'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ConfirmEmailPage;
